import { render, staticRenderFns } from "./LoaderText.vue?vue&type=template&id=cc72f9a4&scoped=true&"
import script from "./LoaderText.vue?vue&type=script&lang=ts&"
export * from "./LoaderText.vue?vue&type=script&lang=ts&"
import style0 from "./LoaderText.vue?vue&type=style&index=0&id=cc72f9a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc72f9a4",
  null
  
)

export default component.exports